const updateNestedField = (obj, pathArray, newValue) => {
  const key = pathArray[0];

  if (!obj || pathArray.length === 0) return obj;

  if (key === "[]") {
    // If it's an array, we need to iterate over each element
    return obj.map((item) => updateNestedField(item, pathArray.slice(1), newValue));
  } else {
    // For objects, keep traversing
    if (pathArray.length === 1) {
      // If it's the last key in the path, update the value
      obj[key] = newValue;
    } else {
      // Otherwise, recurse deeper
      obj[key] = updateNestedField(obj[key], pathArray.slice(1), newValue);
    }
  }

  return obj;
};

export default updateNestedField;
